export enum SearchPageName {
  SA = 'page.Hotel-Search',
  HC = 'page.Package.HC.Hotel-Search',
  FH = 'page.Package.FH.Hotel-Search',
  FHC = 'page.Package.FHC.Hotel-Search'
}

export enum InfositePageName {
  SA = 'page.Hotels.Infosite.Information',
  HC = 'page.HC.Package.Infosite.Information',
  FH = 'page.FH.Package.Infosite.Information',
  FHC = 'page.FHC.Package.Infosite.Information'
}
